import classnames from 'classnames';
import React, { HTMLAttributes, useEffect } from 'react';
import './index.less';

interface ICustomPopover extends Omit<HTMLAttributes<HTMLDivElement>, 'content'> {
    content: () => React.ReactNode;
    setVisible: (value: boolean) => void;
    customClass?: string;
    excludeClass?: string[];
}

const CustomPopover: React.FC<ICustomPopover> = ({ content, style, excludeClass = [], setVisible, customClass }) => {
    useEffect(() => {
        const fn = (e: Event) => {
            let dom = e.target as Element | null;
            while (dom) {
                // 寻找到body
                if (dom.nodeName === 'BODY') {
                    dom = null;
                    setVisible(false);
                    return;
                }
                const classList: string[] = Array.from(dom.classList);
                const intersection = classList.filter((v) => excludeClass.includes(v));
                if (intersection.length) {
                    dom = null;
                } else {
                    dom = dom.parentNode as Element;
                }
            }
        };

        document.addEventListener('click', fn, true);
        return () => {
            document.removeEventListener('click', fn, true);
        };
    }, []);

    return (
        <div className={classnames('custom-popover', customClass)} style={style}>
            {content()}
        </div>
    );
};

export default CustomPopover;
